import { useParams, Link, Navigate } from 'react-router-dom';
import { getPostBySlug } from '../content/blogContent';
import { ArrowLeft, Clock, Calendar } from 'lucide-react';
import { useEffect } from 'react';

function BlogPost() {
    const { slug } = useParams();
    const post = getPostBySlug(slug);

    // Scroll to top when post loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!post) {
        return <Navigate to="/blog" replace />;
    }

    return (
        <div className="container fade-in" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1rem' }}>
            <Link
                to="/blog"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: 'var(--primary)',
                    textDecoration: 'none',
                    marginBottom: '2rem',
                    fontWeight: '600'
                }}
            >
                <ArrowLeft size={20} />
                Back to Blog
            </Link>

            <article>
                <header style={{ marginBottom: '2rem' }}>
                    <div style={{ marginBottom: '1rem' }}>
                        <span
                            style={{
                                display: 'inline-block',
                                padding: '0.25rem 0.75rem',
                                backgroundColor: 'var(--primary-light)',
                                color: 'var(--primary)',
                                borderRadius: '4px',
                                fontSize: '0.875rem',
                                fontWeight: '600'
                            }}
                        >
                            {post.category}
                        </span>
                    </div>

                    <h1 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1rem' }}>
                        {post.title}
                    </h1>

                    <div style={{ display: 'flex', gap: '1.5rem', color: 'var(--text-secondary)', fontSize: '0.875rem', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <Calendar size={16} />
                            <span>{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <Clock size={16} />
                            <span>{post.readTime}</span>
                        </div>
                    </div>
                </header>

                <div
                    className="blog-content"
                    style={{
                        lineHeight: '1.8',
                        color: 'var(--text-primary)',
                        fontSize: '1.0625rem'
                    }}
                    dangerouslySetInnerHTML={{
                        __html: post.content
                            .split('\n')
                            .map(line => {
                                // Convert markdown headers
                                if (line.startsWith('# ')) {
                                    return `<h1 style="font-size: 2rem; margin-top: 2rem; margin-bottom: 1rem; line-height: 1.3;">${line.slice(2)}</h1>`;
                                }
                                if (line.startsWith('## ')) {
                                    return `<h2 style="font-size: 1.75rem; margin-top: 2rem; margin-bottom: 1rem; line-height: 1.3;">${line.slice(3)}</h2>`;
                                }
                                if (line.startsWith('### ')) {
                                    return `<h3 style="font-size: 1.5rem; margin-top: 1.5rem; margin-bottom: 0.75rem; line-height: 1.3;">${line.slice(4)}</h3>`;
                                }
                                // Convert bold
                                line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                                // Convert paragraphs
                                if (line.trim() && !line.startsWith('<')) {
                                    return `<p style="margin-bottom: 1rem;">${line}</p>`;
                                }
                                return line;
                            })
                            .join('')
                    }}
                />
            </article>

            <div className="card" style={{ marginTop: '3rem', backgroundColor: 'var(--primary-light)', border: 'none' }}>
                <h3 style={{ marginTop: 0, color: '#1e293b' }}>Try It Yourself</h3>
                <p style={{ marginBottom: '1.5rem', color: '#475569' }}>
                    Use our calculator to apply what you've learned and explore your mortgage options
                </p>
                <Link
                    to="/"
                    className="btn btn-primary"
                    style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                    Use Calculator
                </Link>
            </div>
        </div >
    );
}

export default BlogPost;
